import type { IUserManagementResult } from '../../../../models/user-management/UserManagementModel';
import styles from '../UserManagement.module.css';

export type UserStatusCellProps = {
  row: IUserManagementResult;
};

const UserStatusCell = ({ row }: UserStatusCellProps) => {
  return (
    <span
      className={`${styles.statusBadge} ${row.isActive ? styles.statusActive : styles.statusInactive}`}
    >
      {row.isActive ? 'Aktif' : 'Pasif'}
    </span>
  );
};

export default UserStatusCell;
